import { ANNUAL, MONTHLY, ONE_TIME } from '@/_pages/agreements/shared/schemas/agreements-query-schema';

type PriceFrequencyLike = { name: string } | null | undefined;

export type PriceFrequencyLetterDisplay = {
  letter: string;
  tooltipLabel: string;
};

/**
 * Maps invoice line-item price frequency to a single letter (M/A/O) with a canonical tooltip label.
 * Unknown names fall back to the first character and the full name as the tooltip.
 */
export function getPriceFrequencyLetterDisplay(priceFrequency: PriceFrequencyLike): PriceFrequencyLetterDisplay {
  const raw = priceFrequency?.name?.trim();
  if (!raw) {
    return { letter: '—', tooltipLabel: '—' };
  }

  const lower = raw.toLowerCase();

  if (raw === MONTHLY || lower === 'monthly' || lower.includes('monthly')) {
    return { letter: 'M', tooltipLabel: 'Monthly' };
  }

  if (
    raw === ANNUAL ||
    lower === 'annual' ||
    lower === 'annually' ||
    lower.includes('annual') ||
    lower.includes('yearly')
  ) {
    return { letter: 'A', tooltipLabel: 'Annually' };
  }

  if (raw === ONE_TIME || lower === 'one-time' || lower === 'one time' || /^one[\s-]?time\b/.test(lower)) {
    return { letter: 'O', tooltipLabel: 'One-Time' };
  }

  const letter = raw.charAt(0) ? raw.charAt(0).toUpperCase() : '—';
  return { letter, tooltipLabel: raw };
}
